import React, { useEffect, useState } from "react";

function TopClientsDetails({ table_data }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    let datat = [];
    table_data?.forEach((item) => {
      datat.push({
        client_name: item.name,
        sector: item.industry,
        type: item.client_type,
        growth:
              (Number(item.previous_revenue ?? 0) === 0
                ? (Number(item.current_revenue ?? 0) !== 0 ? 100 : 0)
                : ((Number(item.current_revenue ?? 0) -
                    Number(item.previous_revenue ?? 0)) /
                    Number(item.previous_revenue)) * 100
              ).toFixed(2),
        pe: item.private_equity,
        gcc: item.gcc,
      });
    });
    console.log(table_data);
    setData(datat);
  }, [table_data]);

  return (
    <>
      <style>
        {`
                    .table thead tr th {
                        white-space: normal !important;
                        word-wrap: break-word;
                        padding: 6px 8px;
                    }
                    
                    .table tbody tr td {
                    color : #202c4b;
                    }
                `}
      </style>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Sector</th>
              <th>Type</th>
              <th>growth (YOY)</th>
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 &&
              data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <h6 className="fw-medium">
                      {item.client_name}
                      <span className="badge badge-xs bg-primary ms-1">
                        {item.pe === "yes" && "PE"}
                      </span>
                      <span className="badge badge-xs bg-info ms-1">
                        {item.gcc === "yes" && "GCC"}
                      </span>
                    </h6>
                  </td>
                  <td>{item.sector}</td>
                  <td>{item.type}</td>
                  <td>
                    <h6
                      className={`fw-medium ${
                        item.growth > 0 || item.type === "NEW"
                          ? "text-success"
                          : "text-danger"
                      }`}
                    >
                      {item.growth}%
                    </h6>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TopClientsDetails;
